import toast from 'react-hot-toast';

export const isFormValid = (formData) => {
  if (formData.datum === null || formData.datum === '') {
    toast.error('Datum je obavezno polje');
    return true;
  }
  if (formData.idMasine === null || formData.idMasine === 0) {
    toast.error('Mašina je obavezno polje');
    return true;
  }
  return false;
};
